import React from 'react'

import { Text, FontFamily, FontWeight, Color } from '@gousto-internal/citrus-react'
import { Recipe } from '@library/menu-service'

export const ProteinText = ({ recipe }: { recipe: Recipe }) => {
  const proteinToDisplay = recipe.nutritionalInformation.perPortion.proteinMg

  if (!proteinToDisplay) {
    return null
  }

  return (
    <Text
      size={2}
      fontFamily={FontFamily.Book}
      fontWeight={FontWeight.Normal}
      color={Color.ColdGrey_600}
    >
      •&nbsp;&nbsp;{`${(proteinToDisplay / 1000).toFixed(1)}g protein`}
    </Text>
  )
}
